import { convertToDarkRgba } from '../utils/convertToDarkRgba';
export const tags = ({ colors }) => {
    const defaultTag = {
        bg: colors.white,
        borderColor: colors.asphalt,
        color: colors.asphalt,
        hovered: {
            bg: convertToDarkRgba(colors.primary),
            borderColor: convertToDarkRgba(colors.primary),
            color: colors.white,
        },
        selected: {
            bg: colors.primary,
            borderColor: colors.primary,
            color: colors.white,
        },
    };
    return {
        primary: defaultTag,
        secondary: Object.assign(Object.assign({}, defaultTag), { hovered: {
                bg: colors.dove,
                borderColor: colors.dove,
                color: colors.white,
            }, selected: {
                bg: colors.asphalt,
                borderColor: colors.asphalt,
                color: colors.white,
            } }),
    };
};
//# sourceMappingURL=tags.js.map